import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=a309c028&scoped=true"
import script from "./blocks.vue?vue&type=script&lang=js"
export * from "./blocks.vue?vue&type=script&lang=js"
import style0 from "./blocks.vue?vue&type=style&index=0&id=a309c028&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a309c028",
  null
  
)

export default component.exports